<div class="teamMemberCard_container" [style.height]="cardHeight" [ngClass]="{'is-highlighted': highlight}">
    <div class="teamMemberCard_topPartContainer">
        <div class="teamMemberCard_topPartContent">
            <div class="teamMemberCard_nameContainer">
                @if(isDiscoveryDone && showTotalEnergyLevel){
                <div class="teamMemberCard_progressBar" aria-valuenow="score" aria-valuemin="0" aria-valuemax="100" [style.--value]="score" [style.--fg]="scoreColor">
                    <span class="teamMemeberCard_score">{{score === 0 ? '⏳' : score}}</span>
                </div> 
                }
                <div class="teamMemberCard_nameAndScore">
                    <span class="teamMemberCard_name">
                        {{teamMemberDetails.firstName}} {{teamMemberDetails.lastName}}
                    </span>
                </div>
                @if(presentLeaderLabel){
                    <app-claro-label 
                        class="teamMemberCard_leaderLabel" 
                        [height]="'25px'" 
                        [colorScheme]="'#F56646'"
                        [width]="'fit-content'" 
                        [fontSize]="isMobileView? '12px':'14px'" 
                        [labelText]="'teamMemberCard.leaderLabel' | translate">
                    </app-claro-label>
                }
            </div>    
            <app-claro-mini-image-button 
            *ngIf="presentDriverMoovsForTeam"
            [image]="'add'"
            (clickEvent)="increateEngagementForTeamMember()">
            </app-claro-mini-image-button>
        </div>
        <mat-divider *ngIf="viewType != viewTypeEnum.CLEAN" class="teamMemberCard_divider"></mat-divider>    
    </div>
    <div *ngIf="isDiscoveryDone" class="teamMemberCard_partContainer">
        <div *ngIf="viewType == viewTypeEnum.MINIMAL" class="teamMemberCard_dataContainer minimal">
            <div class="teamMemberCard_scoreContainer">
                <!-- <div class="teamMemberCard_progressBar" role="progressbar" aria-valuenow="score" aria-valuemin="0" aria-valuemax="100" [style]="{'--value':score}" [style.--fg]="scoreColor"></div> -->
                 <div class="teamMemberCard_motivationsIcons">
                    <span *ngFor="let currMotivation of sortedMotivations" class="teamMemberCard_minimalMotivation">
                        <mat-icon class="teamMembeCard_motivationIcon"  [style.cursor]="'pointer'" [style.color]="getMotivationColor(currMotivation)" (click)="driverMoov(currMotivation)">{{getMotivationIconName(currMotivation)}}</mat-icon>
                        <span class="teamMemberCard_motivationNameMinimal">{{getMotivationName(currMotivation)}}</span>
                    </span>
                 </div>
            </div>     
            <div class="teamMemberCard_actionButtons">
                <!-- <button mat-mini-fab class="teamMemberCard_emergencyChargeButton" (click)="openDetails()">
                    <mat-icon>battery_charging_full</mat-icon>
                </button> -->
                <app-claro-mini-image-button *ngIf="presentEmergancyCharge" [image]="'offline_bolt'" [isHighlighted]="true" (clickEvent)="rechargeTeamMember()"></app-claro-mini-image-button>
                <app-claro-mini-image-button *ngIf="showChatButton" [image]="'chat'" [isHighlighted]="true" (clickEvent)="chatAboutTeamMember()"></app-claro-mini-image-button>
                <!-- <button mat-raised-button class="teamMemberCard_buttonRedHue" (click)="rechargeTeamMember()">{{'quickActions.subject_emergancy' | translate}}</button> -->
                <app-claro-mini-image-button [image]="'keyboard_arrow_down'" (clickEvent)="openDetails()"></app-claro-mini-image-button>
            </div>        
        </div>          
        <div *ngIf="viewType == viewTypeEnum.FULL" class="teamMemberCard_dataContainer full">
            <div class="teamMemberCard_scoreContainer">
                 <div class="teamMembeCard_motivationsTags">
                    <!-- <app-claro-tag *ngFor="let currMotivation of sortedMotivations" [backgroundColor]="getMotivationColor(currMotivation)" [iconName]="getMotivationIconName(currMotivation)" [text]="getMotivationName(currMotivation)"></app-claro-tag> -->
                  

                    <app-driver-level *ngFor="let currMotivation of sortedMotivations"  
                        [icon]="getMotivationIconName(currMotivation)"
                        [level]="getMotivationLevel(currMotivation)" 
                        [name]="getMotivationName(currMotivation)"
                        [isMemberInCareerProcess]="isMemberInCareerProcess"
                        [showEnergyLevels]="showEnergyLevels" 
                        [presentRaiseLevel]="presentDriverMoovsForTeam" 
                        (driverIconClicked)="driverMoov(currMotivation)"
                        (driverNameClicked)="openDriverDetails(currMotivation)"
                        >
                  

                    </app-driver-level>
                 </div>             
            </div>     
            <div class="teamMemberCard_actionButtons">
                <!-- <button mat-mini-fab class="teamMemberCard_emergencyChargeButton" (click)="openDetails()">
                    <mat-icon>battery_charging_full</mat-icon>
                </button> -->
                <app-claro-mini-image-button *ngIf="presentEmergancyCharge" [image]="'offline_bolt'" [isHighlighted]="true" (clickEvent)="rechargeTeamMember()"></app-claro-mini-image-button>
                <app-claro-mini-image-button *ngIf="showChatButton" [image]="'chat'" [isHighlighted]="true" (clickEvent)="chatAboutTeamMember()"></app-claro-mini-image-button>
                <!-- <button mat-raised-button class="teamMemberCard_buttonRedHue" (click)="rechargeTeamMember()">{{'quickActions.subject_emergancy' | translate}}</button> -->
                <app-claro-mini-image-button *ngIf="showDetailsButton" [image]="'demography'" (clickEvent)="openDetails()"></app-claro-mini-image-button>
            </div>        
        </div>
        <div *ngIf="viewType == viewTypeEnum.CLEAN" class="teamMemberCard_dataContainer full">
            <div class="teamMemberCard_actionButtons empty">
                <!-- <button mat-mini-fab class="teamMemberCard_emergencyChargeButton" (click)="openDetails()">
                    <mat-icon>battery_charging_full</mat-icon>
                </button> -->
                <app-claro-mini-image-button *ngIf="presentEmergancyCharge" [image]="'offline_bolt'" [isHighlighted]="true" (clickEvent)="rechargeTeamMember()"></app-claro-mini-image-button>
                <app-claro-mini-image-button *ngIf="showChatButton" [image]="'chat'" [isHighlighted]="true" (clickEvent)="chatAboutTeamMember()"></app-claro-mini-image-button>

                <!-- <button mat-raised-button class="teamMemberCard_buttonRedHue" (click)="rechargeTeamMember()">{{'quickActions.subject_emergancy' | translate}}</button> -->
                <app-claro-mini-image-button *ngIf="showDetailsButton" [image]="'demography'" (clickEvent)="openDetails()"></app-claro-mini-image-button>
            </div>        
        </div>         
    </div>
    <div *ngIf="!isDiscoveryDone" class="teamMemberCard_partContainer">
        <div class="teamMemberCard_dataContainer empty">
            <div class="teamMemberCard_alertContainer">
                    <app-claro-tag [backgroundColor]="'#FFC107'" [iconName]="'warning'" [text]="'team.pendingDiscovery'| translate"></app-claro-tag>
            </div>             
            <div class="teamMemberCard_actionButtons empty">
                <!-- <button mat-mini-fab color="primary" (click)="openDetails()">
                  <mat-icon>info</mat-icon>
                </button> -->
                <app-claro-mini-image-button *ngIf="showDetailsButton" [image]="'demography'" (clickEvent)="openDetails()"></app-claro-mini-image-button>
            </div>        
        </div>   
    </div>
        <!-- <span>score is {{score}}</span> -->
        <!-- <div class="progress-bar" role="progressbar" aria-valuenow="score" aria-valuemin="0" aria-valuemax="100" [ngStyle]="{'background':'radial-gradient(closest-side, white 79%, transparent 80% 100%), conic-gradient(hotpink 50%, pink 0);'}"></div> -->
    

    <!-- <span class="teamMemberCard_score" *ngFor="let currMotivation of teamMemberDetails.motivations">
        {{currMotivation}} {{teamMemberDetails.motivationsGap[currMotivation]}}
    </span> -->
</div>
